import type { RootState } from 'APP/Store/CreateStore'

export const selectPractitionerId = (state: RootState) => state.videoSession.practitionerId
